export default function (lodash, FormFactory) {
    const create = (list, formModel) => {
        const filter = FormFactory.create(formModel, query => list.fetch(lodash.extend({}, list.lastQuery, query)));
        filter.fetch = () => filter.save();
        filter.reset = lodash.wrap(filter.reset, (reset) => {
            reset();
            return filter.fetch();
        });
        return filter;
    };
    return {
        create
    };
}



// WEBPACK FOOTER //
// ./src/app/factories/list/filter/index.js